import { Fragment, useMemo, useState } from 'react';
import styled from 'styled-components';
import Big from 'UIComponents/elements/Big';
import UIBreakString from 'UIComponents/text/UIBreakString';
import UIClickable from 'UIComponents/button/UIClickable';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIImage from 'UIComponents/image/UIImage';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UILightbox from 'UIComponents/lightbox/UILightbox';
import UISection from 'UIComponents/section/UISection';
import { useFocusCloseButton } from 'marketplace-ui-common/hooks/useFocusCloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IMAGE_WIDTH = 280;
const FeatureParagraph = styled.p.withConfig({
  displayName: "FeatureCard__FeatureParagraph",
  componentId: "sc-1hkyjej-0"
})(["white-space:pre-line;"]);
export default function FeatureCard({
  className,
  children,
  feature,
  onImageClick
}) {
  const [showLightBox, setShowLightBox] = useState(false);
  useFocusCloseButton(showLightBox);
  const {
    title,
    description,
    imageUrl
  } = feature;
  const renderedLightbox = useMemo(() => showLightBox && feature.imageUrl && /*#__PURE__*/_jsx(UILightbox, {
    imageAlt: feature.description,
    imageSrc: feature.imageUrl,
    onClose: () => setShowLightBox(false),
    children: /*#__PURE__*/_jsx(UIButtonWrapper, {
      children: feature.description
    })
  }), [feature, showLightBox, setShowLightBox]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UISection, {
      className: className,
      children: /*#__PURE__*/_jsxs(UIGrid, {
        children: [/*#__PURE__*/_jsxs(UIGridItem, {
          size: {
            sm: 12,
            md: 7
          },
          children: [/*#__PURE__*/_jsx(Big, {
            weight: "bold",
            children: /*#__PURE__*/_jsx(UIBreakString, {
              children: title
            })
          }), /*#__PURE__*/_jsx(FeatureParagraph, {
            children: /*#__PURE__*/_jsx(UIBreakString, {
              children: description
            })
          }), children]
        }), /*#__PURE__*/_jsx(UIGridItem, {
          size: {
            sm: 12,
            md: 5
          },
          children: imageUrl && /*#__PURE__*/_jsx(UIClickable, {
            onClick: () => {
              setShowLightBox(true);
              if (onImageClick) {
                onImageClick();
              }
            },
            children: /*#__PURE__*/_jsx(UIImage, {
              alt: title,
              responsive: true,
              src: imageUrl,
              width: IMAGE_WIDTH
            })
          })
        })]
      })
    }, `feature-${title}`), renderedLightbox]
  });
}